import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { clientActions, generalActions } from "../actions";
import api from "../services/clients.service";
import ACTIONS from "../constants";
import {
  clientsPagination,
  portfoliosPagination,
} from "../selectors/clients.selector";

function* getClients(state) {
  try {
    yield put(clientActions.getClientsAttempt.pending);
    const clients = yield call(api.clientsRequest, state.payload);
    const pagination = JSON.parse(clients.headers["x-pagination"]);
    const data = {
      data: clients.data,
      pagination: pagination,
    };
    yield put(clientActions.getClientsAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(clientActions.getClientsAttempt.error(""));
    } else {
      yield put(clientActions.getClientsAttempt.error(error.message));
    }
  }
}

function* sortClients(state) {
  try {
    yield put(clientActions.sortClientAttempt.pending);
    const clients = yield call(api.sortClientsRequest, state.payload);
    const pagination = JSON.parse(clients.headers["x-pagination"]);
    const data = {
      data: clients.data,
      pagination: pagination,
    };
    yield put(clientActions.sortClientAttempt.success(data));
  } catch (error) {
    yield put(clientActions.sortClientAttempt.error(error));
  }
}

function* createClient(state) {
  try {
    yield put(clientActions.createClientAttempt.pending);
    yield call(api.createClientRequest, state.payload);
    // const paginat = yield select(clientsPagination);
    const clients = yield call(api.clientsRequest, {
      page: 1,
      size: state.payload.perPageItems,
    });
    const pagination = JSON.parse(clients.headers["x-pagination"]);
    const data = {
      data: clients.data,
      pagination: pagination,
    };
    yield put(clientActions.createClientAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Client saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        clientActions.createClientAttempt.error(errorObject.data.Name[0])
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        clientActions.createClientAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        clientActions.createClientAttempt.error(errorObject.data.errors)
      );
      // yield put(clientActions.createClientAttempt.error(errorObject.data.errors[0].message));
    }
  }
}

function* updateClient(state) {
  try {
    yield put(clientActions.updateClientAttempt.pending);
    yield call(api.updateClientRequest, state.payload);
    const paginat = yield select(clientsPagination);
    let clients;
    if (state.payload.type === "overview") {
      clients = yield call(api.getClientDetailsRequest, state.payload);
      const data = {
        type: state.payload.type,
        data: clients,
      };
      yield put(clientActions.updateClientAttempt.success(data));
    } else {
      clients = yield call(api.clientsRequest, {
        page: paginat.CurrentPage,
        size: paginat.PageSize,
      });
      const pagination = JSON.parse(clients.headers["x-pagination"]);
      const data = {
        type: state.payload.type,
        data: clients.data,
        pagination: pagination,
      };
      yield put(clientActions.updateClientAttempt.success(data));
    }
    // const clients = yield call(api.clientsRequest, {page: paginat.CurrentPage, size:paginat.PageSize });
    // const pagination = JSON.parse(clients.headers['x-pagination']);
    // const data = {
    //   type: state.payload.type,
    //   data: clients.data,
    //   pagination: pagination
    // }
    // yield put(clientActions.updateClientAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Client updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(clientActions.updateClientAttempt.error(errorObject));
      } else {
        yield put(
          clientActions.updateClientAttempt.error(errorObject.data.errors)
        );
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        clientActions.updateClientAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        clientActions.updateClientAttempt.error(errorObject.data.errors)
      );
      // yield put(clientActions.updateClientAttempt.error(errorObject.data.errors[0].message));
    }
  }
}

function* deleteClient(state) {
  try {
    yield put(clientActions.deleteClientAttempt.pending);
    yield call(api.deleteClientRequest, state.payload);
    const paginat = yield select(clientsPagination);
    const clients = yield call(api.clientsRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(clients.headers["x-pagination"]);
    const data = {
      data: clients.data,
      pagination: pagination,
    };
    yield put(clientActions.deleteClientAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Client deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(clientActions.deleteClientAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(clientActions.deleteClientAttempt.error(error));
    }
    if (errorObject.status === 400) {
      yield put(clientActions.deleteClientAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* getClientDetails(state) {
  try {
    yield put(clientActions.getClientDetailsAttempt.pending);
    const client = yield call(api.getClientDetailsRequest, state.payload);
    yield put(clientActions.getClientDetailsAttempt.success(client));
  } catch (error) {
    yield put(clientActions.getClientDetailsAttempt.error(error));
  }
}

function* updateClientFlag(state) {
  try {
    yield put(clientActions.updateClientFlagAttempt.pending);
    yield call(api.updateClientFlagRequest, state.payload);
    yield put(clientActions.updateClientFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Clients flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
    yield put(clientActions.updateClientFlagAttempt.error(error));
  }
}

////////////////////////////////////////////////// PORTFOLIOS //////////////////////////////////////////////////

function* getPortfolios(state) {
  try {
    yield put(clientActions.getPortfoliosAttempt.pending);
    const portfolios = yield call(api.portfoliosRequest, state.payload);
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(clientActions.getPortfoliosAttempt.success(data));
  } catch (error) {
    yield put(clientActions.getPortfoliosAttempt.error(error.message));
  }
}

function* sortPortfolios(state) {
  try {
    yield put(clientActions.sortPortfoliosAttempt.pending);
    const portfolios = yield call(api.sortPortfoliosRequest, state.payload);
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(clientActions.sortPortfoliosAttempt.success(data));
  } catch (error) {
    yield put(clientActions.sortPortfoliosAttempt.error(error));
  }
}

function* createPortfolio(state) {
  try {
    yield put(clientActions.createPortfolioAttempt.pending);
    yield call(api.createPortfolioRequest, state.payload);
    const paginat = yield select(portfoliosPagination);
    const portfolios = yield call(api.portfoliosRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(clientActions.createPortfolioAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Portfolio saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 422) {
      yield put(
        clientActions.createPortfolioAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        clientActions.createPortfolioAttempt.error(errorObject.data.errors)
      );
    }
  }
}

function* updatePortfolio(state) {
  try {
    yield put(clientActions.updatePortfolioAttempt.pending);
    yield call(api.updatePortfolioRequest, state.payload);
    const paginat = yield select(portfoliosPagination);
    const portfolios = yield call(api.portfoliosRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(clientActions.updatePortfolioAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Portfolio updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 422) {
      yield put(
        clientActions.updatePortfolioAttempt.error(errorObject.data.Name[0])
      );
    }
    if (errorObject.status === 400) {
      yield put(
        clientActions.updatePortfolioAttempt.error(errorObject.data.errors)
      );
      // yield put(clientActions.updatePortfolioAttempt.error(errorObject.data.errors[0].message));
    }
  }
}

function* deletePortfolio(state) {
  try {
    yield put(clientActions.deletePortfolioAttempt.pending);
    yield call(api.deletePortfolioRequest, state.payload);
    const paginat = yield select(portfoliosPagination);
    const portfolios = yield call(api.portfoliosRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(clientActions.deletePortfolioAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Portfolio deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      generalActions.showToast({
        title: `${error}`,
        type: "Error",
      })
    );
    yield put(clientActions.deletePortfolioAttempt.error(error));
  }
}

////////////////////////////////////////////////// PORTFOLIOS //////////////////////////////////////////////////

function* getClientResources(state) {
  try {
    yield put(clientActions.getClientResourcesAttempt.pending);
    const resources = yield call(
      api.getAllocatedResourcesRequest,
      state.payload
    );
    const pagination = JSON.parse(resources.headers["x-pagination"]);
    const data = {
      data: resources.data,
      pagination: pagination,
    };
    yield put(clientActions.getClientResourcesAttempt.success(data));
  } catch (error) {
    yield put(clientActions.getClientResourcesAttempt.error(error.message));
  }
}

function* sortClientResources(state) {
  try {
    yield put(clientActions.sortClientResourcesAttempt.pending);
    const resources = yield call(
      api.sortAllocatedResourcesRequest,
      state.payload
    );
    const pagination = JSON.parse(resources.headers["x-pagination"]);
    const data = {
      data: resources.data,
      pagination: pagination,
    };
    yield put(clientActions.sortClientResourcesAttempt.success(data));
  } catch (error) {
    yield put(clientActions.sortClientResourcesAttempt.error(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(ACTIONS.CLIENTS_CALL, getClients)]);
  yield all([takeEvery(ACTIONS.SORT_CLIENTS_CALL, sortClients)]);
  yield all([takeEvery(ACTIONS.CREATE_CLIENT_CALL, createClient)]);
  yield all([takeEvery(ACTIONS.UPDATE_CLIENT_CALL, updateClient)]);
  yield all([takeEvery(ACTIONS.DELETE_CLIENT_CALL, deleteClient)]);
  yield all([takeEvery(ACTIONS.GET_CLIENT_DETAILS_CALL, getClientDetails)]);
  yield all([takeEvery(ACTIONS.CLIENT_FLAG_CALL, updateClientFlag)]);
  yield all([takeEvery(ACTIONS.CLIENT_PORTFOLIOS_CALL, getPortfolios)]);
  yield all([takeEvery(ACTIONS.SORT_CLIENT_PORTFOLIOS_CALL, sortPortfolios)]);
  yield all([
    takeEvery(ACTIONS.CREATE_CLIENT_PORTFOLIOS_CALL, createPortfolio),
  ]);
  yield all([
    takeEvery(ACTIONS.UPDATE_CLIENT_PORTFOLIOS_CALL, updatePortfolio),
  ]);
  yield all([
    takeEvery(ACTIONS.DELETE_CLIENT_PORTFOLIOS_CALL, deletePortfolio),
  ]);
  yield all([takeEvery(ACTIONS.CLIENT_RESOURCES_CALL, getClientResources)]);
  yield all([
    takeEvery(ACTIONS.SORT_CLIENT_RESOURCES_CALL, sortClientResources),
  ]);
}
